if (!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);

      this.querySelector('[js-product-swatch-ele]')
        ?.addEventListener('click', this.handleClick);
    }

    handleClick(e) {
      e.preventDefault();
      const productUrl = this.dataset.productUrl;
      if (!productUrl) {
        return;
      }
      this.renderSections(productUrl);
    }

    getSectionsToRender() {
      return [
        {
          selector: 'js-product-info',
          sectionId: this.closest('[js-product-info]')?.dataset.section,
        },
      ];
    }

    renderSections(productUrl) {
        this.getSectionsToRender().forEach(section=> {
          let url = `${location.origin}${productUrl}?section_id=${section.sectionId}`;

           if(section.sectionId != undefined) {
              fetch(`${url}`)
              .then(response=>response.text())
              .then(html=>{
    
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const productInfoAjax = doc.querySelector(`[${section.selector}]`);
                  const productInfo = document.querySelector(`[${section.selector}]`);

                  const elementToReplace = productInfo?.querySelector('.product-information__media');
                  const elementAjax = productInfoAjax?.querySelector('.product-information__media');

                  
                  if(elementToReplace && elementAjax ) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.replaceWith(elementAjax)
                  }
                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }
  }

  customElements.define('product-swatch', ProductSwatch);
}